// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__JP0PX","createdSearch":"index_createdSearch__SQMtt","custom_table":"index_custom_table__YNvTm"};